// extracted by mini-css-extract-plugin
export default {"container":"current-filter-list_container__UIIaL"};